/**
 * Club currency types
 */
export enum ClubCurrencyType {
  EUR = 'EUR',
  CHF = 'CHF',
}
